import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setAuthedUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || window.location.hash;
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const res = await api.post("/auth/google/session", { session_id: sessionId });
        setAuthedUser(res.data.user, res.data.session_token);
        // Strip the hash & redirect home
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true });
      } catch (e) {
        const msg = e.response?.data?.detail || e.message || "Sign-in failed";
        setError(typeof msg === "string" ? msg : JSON.stringify(msg));
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-gray-50">
      <div className="max-w-md w-full bg-white border border-gray-200 rounded-xl p-8 text-center">
        {error ? (
          <>
            <h1 className="font-display text-lg font-semibold text-gray-900">Sign-in failed</h1>
            <p className="mt-2 text-sm text-red-600" data-testid="auth-callback-error">{error}</p>
            <button
              onClick={() => navigate("/login", { replace: true })}
              className="mt-5 inline-flex items-center justify-center rounded-md bg-gray-900 text-white text-sm font-medium px-4 py-2 hover:bg-gray-800"
              data-testid="auth-callback-back-btn"
            >
              Back to login
            </button>
          </>
        ) : (
          <p className="text-sm text-gray-500" data-testid="auth-callback-loading">Signing you in…</p>
        )}
      </div>
    </div>
  );
}
